import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card h-100" }
const _hoisted_2 = { class: "card-body p-2 d-flex align-items-center justify-content-center" }
const _hoisted_3 = { style: {"height":"200px","width":"100%"} }
const _hoisted_4 = {
  key: 1,
  class: "h-100 d-flex flex-column align-items-center justify-content-center text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_radar_chart = _resolveComponent("radar-chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h5", { class: "text-truncate mb-0" }, [
        _createElementVNode("i", { class: "fas fa-crosshairs fa-fw text-danger" }),
        _createElementVNode("span", null, " RRR Distribución")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.hasData)
          ? (_openBlock(), _createBlock(_component_radar_chart, {
              key: 0,
              data: _ctx.chartData,
              options: _ctx.chartOptions,
              plugins: _ctx.plugins
            }, null, 8, ["data", "options", "plugins"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "fas fa-chart-pie fa-2x mb-2 opacity-50" }, null, -1),
              _createElementVNode("small", null, "Sin datos suficientes", -1)
            ]))]))
      ])
    ])
  ]))
}